module.exports = __webpack_public_path__ + "static/media/soy.968d179a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/soy.svg
// module id = 1120
// module chunks = 0